// extracted by mini-css-extract-plugin
export default {"wrapper":"BoxSection_wrapper__Y-GUr","stackList":"BoxSection_stackList__dcA7m","item":"BoxSection_item__zUaGE"};